export function initLegalInfo(isLoopedSlider) {
  const $legalInfoItems = isLoopedSlider ? $('.swiper-slide-duplicate .teaser-legal-infos') : $('.teaser-legal-infos');

  $legalInfoItems.each((index, legalInfoItem) => {
    const $legalInfoItem = $(legalInfoItem);
    const $openButton = $legalInfoItem.find('.teaser-legal-infos__button');
    const $closeButton = $legalInfoItem.find('.teaser-legal-infos__button-close');
    const $content = $legalInfoItem.find('.teaser-legal-infos__content');
    const $companionSlider = $legalInfoItem.parents('.apn-hero-teaser-compagnion');
    let $heroSliderInstance;

    $openButton.on('click', (e) => {
      e.preventDefault();
      $content.show();
      if ($legalInfoItem.hasClass('teaser-legal-infos--slider')) {
        if (!$companionSlider.length) {
          hideLegalInfoOnSlide($legalInfoItem);
          pauseSlider($legalInfoItem.parents('.swiper-container'));
        } else {
          $heroSliderInstance = $companionSlider.prev().find('.swiper-container');
          hideLegalInfoOnSlide($legalInfoItem);
          pauseSlider($heroSliderInstance);
        }
      }
    });
    $closeButton.on('click', (e) => {
      e.preventDefault();
      $content.hide();

      if ($companionSlider.length) {
        resumeSlider($heroSliderInstance);
      } else if ($legalInfoItem.hasClass('teaser-legal-infos--slider') && !$companionSlider.length) {
        resumeSlider($legalInfoItem.parents('.swiper-container'));
      }
    });
  });
}

function hideLegalInfoOnSlide($legalInfoItem) {
  const $legalInfoSliderItemContent = $legalInfoItem.find('.teaser-legal-infos__content');

  const $swiperWrapper = $legalInfoSliderItemContent.parents('.swiper-wrapper');
  const $swiperContainer = $legalInfoSliderItemContent.parents('.swiper-container');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      $legalInfoSliderItemContent.hide();
      resumeSlider($swiperContainer);
      disconnectObserver();
    });
  });

  // Observe Swiper transition
  observer.observe($swiperWrapper[0], {
    attributes: true,
    attributeFilter: ['style'],
  });

  function disconnectObserver() {
    observer.disconnect();
  }
}

function pauseSlider($swiperContainer) {
  const swiperInstance = $swiperContainer[0].swiper;
  swiperInstance.autoplay.pause();
  swiperInstance.autoplay.paused = true;
}

function resumeSlider($swiperContainer) {
  const swiperInstance = $swiperContainer[0].swiper;

  if (swiperInstance.autoplay.paused) {
    swiperInstance.autoplay.start();
    swiperInstance.autoplay.paused = false;
  }
}
